module.exports = "<div class=\"logo\" \n[ngStyle]=\"{'height': height, 'background-position-x': align, \n    'background-image': logoImageCss}\">\n  \n</div>"